import React from 'react';
import useLang from '../../i18n/useLang';
import { Reveal } from '../site/motion';

// The questions plant owners ask before they hire one person to build their systems.
export default function Faq() {
  const { t } = useLang();
  const raw = t('home.faq.items', { returnObjects: true });
  const items = Array.isArray(raw) ? raw : [];
  if (!items.length) return null;

  return (
    <section className="wrap py-24 sm:py-32">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1fr_1.7fr] lg:gap-20">
        <Reveal as="h2" variant="blur" className="heading max-w-[14ch] self-start text-[2.25rem] text-ink sm:text-5xl">
          {t('home.faq.title')}
        </Reveal>
        <div className="border-t border-fog-200">
          {items.map((it, i) => (
            <Reveal key={it.q} delay={i * 50} className="border-b border-fog-200">
              <details className="faq group">
                <summary className="flex min-h-[64px] cursor-pointer list-none items-center justify-between gap-6 py-5 text-start text-lg font-semibold text-ink transition-colors hover:text-grovv-800 [&::-webkit-details-marker]:hidden">
                  <span>{it.q}</span>
                  <span
                    aria-hidden="true"
                    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-ink ring-1 ring-inset ring-fog-300 transition-[transform,background-color,box-shadow] duration-300 group-open:rotate-45 group-open:bg-grovv group-open:ring-grovv"
                  >
                    <svg className="h-3.5 w-3.5" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                      <path d="M7 1.5v11M1.5 7h11" />
                    </svg>
                  </span>
                </summary>
                <div className="faq-a pb-6 pe-12 text-[1.05rem] leading-relaxed text-ink-600">{it.a}</div>
              </details>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
